<template>
  <div class="system-box">
    <el-form :model="eData" label-width="120px" >
      
      <FormEdit
        ref="FormEdit"
        labelWidth="150px"
        :action="$api.url_upload_pu"
        :formItems="formItems"
        :areaIdsChecked="areaIdsChecked"
        @areaChange="areaChange" />
        <!-- @watchChange="watchChange" -->

      <el-form-item label="人事人才网底链接：" label-width="150px">
        <el-button type="success" @click="addHandler">新增</el-button>
        <el-button type="danger" @click="redHandler">删除</el-button>
      </el-form-item>
      <el-form-item style="margin-top:60px;">
        <el-button type="primary" @click="submitHandler">提交</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
// import mixin_form from '@/Mixins/mixin_form'
import FormEdit from '@/components/FormEdit'
export default {
  // mixins: [mixin_form],
  components: { FormEdit },
  data() {
    return {
      areaIdsChecked: this.areaId_x,
      eData: {},
      eData_ori: {},
      times: {
        nameAndUrlList: 0,
      },
    }
  },
  computed: {
    formItems() {
      return [
        { type: 'image', key: 'welcomeImg', label: '系统欢迎图', size: '无', limitNum: 1, index: 1 },
        { type: 'text', key: 'title', label: '主系统名称' },
        { type: 'image', key: 'logoId', label: '主系统logo', size: '120px*120px', limitNum: 1, index: 2 },
        // { type: 'image', key: 'showImgId', label: '地图弹框图片', size: '无', limitNum: 1, index: 2 },
        // { type: 'text', key: 'showDesc', label: '地图弹框描述' },
        // { type: 'text', key: 'policyUrl', label: '政府法规' },
        // { type: 'text', key: 'socialUrl', label: '人社业务' },
        { type: 'text', key: 'rsrcTitle', label: '人事人才系统名称' },
        { type: 'image', key: 'rsrcLogo', label: '人事人才系统logo', size: '120px*120px', limitNum: 1, index: 3 },

        { type: 'text', key: 'holdSide', label: '3g视吧主办方' },
        { type: 'text', key: 'rsrcHoldSide', label: '人事人才主办方' },
        { type: 'text', key: 'maintain', label: '3g视吧维权' },
        { type: 'text', key: 'rsrcMaintain', label: '人事人才维权' },

        { type: 'text', key: 'copyrightOwner', label: '版权所有' },
        { type: 'text', key: 'caseNumber', label: '备案号' },
        { type: 'text', key: 'caseTime', label: '备案时间' },
        { type: 'image', key: 'homeLogoId', label: '首页LOGO图', size: '300px*110px', limitNum: 1, index: 4 },
        { type: 'text', key: 'topDescription', label: '顶部描述', placeholder: '竞成股份 成竞律师 为您服务！全国客服：400-6968-688' },
        { type: 'image', key: 'videoAppDownloadImgId', label: '竞成云视频下载二维码', size: '140px*140px', limitNum: 1, index: 5 },
        { type: 'text', key: 'videoAppDownloadDescription', label: '竞成云视频下载描述1' },
        { type: 'text', key: 'videoAppDownloadDescription2', label: '竞成云视频下载描述2' },
        { type: 'text', key: 'appName', label: 'APP名称' },
        { type: 'image', key: 'appIosDownloadImgId', label: 'IOS下载二维码', size: '140px*140px', limitNum: 1, index: 6 },
        { type: 'image', key: 'appAndroidDownloadImgId', label: '安卓下载二维码', size: '140px*140px', limitNum: 1, index: 7 },
        { type: 'image', key: 'smallSoftImgId', label: '小程序二维码', size: '140px*140px', limitNum: 1, index: 8 },
        { type: 'image', key: 'officialAccountImgId', label: '公众号二维码', size: '140px*140px', limitNum: 1, index: 9 },
        { type: 'image', key: 'weiboImgId', label: '微博二维码', size: '140px*140px', limitNum: 1, index: 10 },

        { type: 'text', key: 'siteName', label: '站点名称' },
        { type: 'text', key: 'customerServicePhone', label: '客服电话' },
        { type: 'text', key: 'complaintEmail', label: '投诉邮件' },
        { type: 'text', key: 'jingchengIntroduction', label: '竞成简介', placeholder: '限制4个字' },
        { type: 'text', key: 'jingchengidea', label: '竞成理念', placeholder: '限制4个字' },
        { type: 'text', key: 'jingchengCulture', label: '竞成文化', placeholder: '限制4个字' },
        { type: 'text', key: 'jingchengTeam', label: '竞成团队', placeholder: '限制4个字' },
        { type: 'text', key: 'jingchengRouteLine', label: '竞成之路', placeholder: '限制4个字' },
        { type: 'text', key: 'jingchengContactUs', label: '联系我们', placeholder: '限制4个字' },
        { type: 'text', key: 'jingchengNews', label: '竞成新闻', placeholder: '限制4个字' },
        { type: 'text', key: 'jingchengActivity', label: '竞成活动', placeholder: '限制4个字' },
        { type: 'image', key: 'helpCenterImgId', label: '帮忙中心封页图', size: '无', limitNum: 1, index: 11, labelSoltcb: this.navToHelp, },

        { type: 'row', key: 'nameAndUrlList', children: [
          { type: 'text', key: 'name', label: '人事人才链接标题', placeholder: '标题与url必须同时填写，否则不生效' },
          { type: 'text', key: 'url', label: '人事人才链接url', placeholder: '标题与url必须同时填写，否则不生效' },
        ], time: this.times.nameAndUrlList }



        // { type: 'select_s', key: 'o_domain', label: '所属行业', options: this.$fuwuData.suoshuhangye3g },
        // { type: 'image', key: 'o_homeUrl', label: '企业logo', size: '120px*120px', limitNum: 1, index: 1 },
        // { type: 'video', key: 'o_videoUrl', label: '视频简介', index: 3 },
      ]
    },
    formItems2() {
      return null
    },
  },
  methods: {
    areaChange(areaIds) { // 切换地区重新请求分站数据
      console.log(areaIds)
      let arr = JSON.parse(JSON.stringify(areaIds)).reverse()
      let id = arr.find(x => x)
      this.$api.getSystem(id).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c分站设置:`, 'color: #f00;', _R)
          _R.topDescription === '' && (_R.topDescription = '竞成股份 成竞律师 为您服务！全国客服：400-6968-688')
          this.eData = _R
          this.eData_ori = _R
          this.$refs.FormEdit.eData = {}
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
          this.times.nameAndUrlList = _R.nameAndUrlList.length
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
          this.$refs.FormEdit.modifyHandler(this.eData)
        } else { this._status(res.data) }
      })
    },
    addHandler() {
      this.times.nameAndUrlList++
      this.$refs.FormEdit.eData.nameAndUrlList.push({ name: '', url: '' })
      // console.log(`%cformItems:`, 'color: #00f;', this.formItems)
      // console.log(`%ceData:`, 'color: #00f;', this.eData)
    },
    redHandler() {
      this.times.nameAndUrlList--
      this.$refs.FormEdit.eData.nameAndUrlList.pop()
      // console.log(`%cformItems:`, 'color: #00f;', this.formItems)
      // console.log(`%ceData:`, 'color: #00f;', this.eData)
    },
    submitHandler() {
      const result = this.$refs.FormEdit.submitHandler()
      // console.log(`%cresult:`, 'color: #00f;', result)
      let rData = {}
      let {
        id,province,city,county,town,village,
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        nameAndUrlList,
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      } = result

// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      if (result.jingchengIntroduction && result.jingchengIntroduction.length !== 4) { this.$message.warning('竞成简介限制4个字');return }
      if (result.jingchengidea && result.jingchengidea.length !== 4) { this.$message.warning('竞成理念限制4个字');return }
      if (result.jingchengCulture && result.jingchengCulture.length !== 4) { this.$message.warning('竞成文化限制4个字');return }
      if (result.jingchengTeam && result.jingchengTeam.length !== 4) { this.$message.warning('竞成团队限制4个字');return }
      if (result.jingchengRouteLine && result.jingchengRouteLine.length !== 4) { this.$message.warning('竞成之路限制4个字');return }
      if (result.jingchengContactUs && result.jingchengContactUs.length !== 4) { this.$message.warning('联系我们限制4个字');return }
      if (result.jingchengNews && result.jingchengNews.length !== 4) { this.$message.warning('竞成新闻限制4个字');return }
      if (result.jingchengActivity && result.jingchengActivity.length !== 4) { this.$message.warning('竞成活动限制4个字');return }
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑


// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      if (!province) { this.$message.warning('请选择地区') }
      // else if (result.jingchengIntroduction.length !== 4) { this.$message.warning('竞成简介限制4个字') }
      // else if (result.jingchengidea.length !== 4) { this.$message.warning('竞成理念限制4个字') }
      // else if (result.jingchengCulture.length !== 4) { this.$message.warning('竞成文化限制4个字') }
      // else if (result.jingchengTeam.length !== 4) { this.$message.warning('竞成团队限制4个字') }
      // else if (result.jingchengRouteLine.length !== 4) { this.$message.warning('竞成之路限制4个字') }
      // else if (result.jingchengContactUs.length !== 4) { this.$message.warning('联系我们限制4个字') }
      // else if (result.jingchengNews.length !== 4) { this.$message.warning('竞成新闻限制4个字') }
      // else if (result.jingchengActivity.length !== 4) { this.$message.warning('竞成活动限制4个字') }
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      else {
        const mapList_must = ['province', 'city', 'county', 'town', 'village']
        mapList_must.forEach(x => {
          rData[x] = result[x] || ''
        })
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        const mapList_unique = [
          'welcomeImg',
          'title',
          'logoId',
          'rsrcTitle',
          'rsrcLogo',
          'holdSide',
          'rsrcHoldSide',
          'maintain',
          'rsrcMaintain',
          // 'officialAccountImgId',

          'copyrightOwner',
          'caseNumber',
          'caseTime',
          'homeLogoId',
          'topDescription',
          'videoAppDownloadImgId',
          'videoAppDownloadDescription',
          'videoAppDownloadDescription2',
          'appName',
          'appIosDownloadImgId',
          'appAndroidDownloadImgId',
          'smallSoftImgId',
          'officialAccountImgId',
          'weiboImgId',
          'siteName',
          'customerServicePhone',
          'complaintEmail',
          'jingchengIntroduction',
          'jingchengidea',
          'jingchengCulture',
          'jingchengTeam',
          'jingchengRouteLine',
          'jingchengContactUs',
          'jingchengNews',
          'jingchengActivity',
          'helpCenterImgId',
          // 'nameAndUrlList',
        ]
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        mapList_unique.forEach(x => {
          if (JSON.stringify(this.eData_ori[x]) !== JSON.stringify(result[x])) {
            rData[x] = result[x]
          }
        })
        rData.id = this.eData_ori.id // 绑定修改的数据id
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        if (JSON.stringify(this.eData_ori.nameAndUrlList) !== JSON.stringify(result.nameAndUrlList)) {
          rData.nameAndUrlList = nameAndUrlList.filter(x => {
            if (x.name && x.url) {
              return x
            }
          })
        }
        // rData.topDescription === '' && (rData.topDescription = '竞成股份 成竞律师 为您服务！全国客服：400-6968-688')
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        console.log(`%crData:`, 'color: #00f;', rData)
        this.$api.editSystemNameLogo(rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('提交成功！')
          } else { this._status(res.data) }
        })
      }
    },

    navToHelp() {
      this.$router.push('/articleDetail?catalog=contactUs&toptitle=联系我们')
    },

    init() {
      let { provinceId, cityId, countyId, townId, villageId } = this.userInfo
      let areaIds = [ provinceId, cityId, countyId, townId, villageId ]
      this.areaChange(areaIds)
    },
  },
  created() {
    this.init()
  },
}
</script>

<style lang='scss' scoped>
.system-box{display: flex;justify-content: center;align-items: center;}





/deep/ .upload-image .el-upload--picture-card,
/deep/ .upload-image .el-upload-list__item {width:90px;height:90px;position:relative;transition:none !important;} // 图片盒子大小
/deep/ .upload-image .el-icon-plus {width:28px;height:28px; position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;} // 图片加号位置
/deep/ .disabled .el-upload--picture-card {display:none} // 图片超出数量限制 隐藏上传按钮

/deep/ .el-form-item__label,
/deep/ .el-cascader__search-input,
/deep/ .el-radio__label {font-size: 12px;}

/deep/ .el-form-item {margin-bottom:10px;} // 设置每行间距


/deep/ .el-input--mini .el-input__icon {line-height: 36px;} // 选择器 icon位置


/deep/.el-select__tags{overflow: auto;}


// 视频 ↓
/deep/.upload-video .el-upload--text {border: 1px dashed #c0ccda;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
/deep/.upload-video .el-upload--text:hover {border-color: #409EFF;color: #409EFF;}
.upload-video-icon {
  width:90px;height:90px;line-height:90px;text-align: center;
  background-color: #fbfdff;font-size: 28px;color: #8c939d;
}
/deep/.el-upload-list--text{width: 400px;}
.video{width: 400px;max-height: 240px;}
/deep/ .disabled .el-upload--text{display: none;}
</style>